import { useEffect, useState } from 'react';

export function useCountDownTimer(interval, countOnInit = true) {
  const [counter, setCounter] = useState(countOnInit ? interval : 0);
  const isCounting = counter > 0;

  useEffect(() => {
    if (!isCounting) return;

    const timer = setInterval(
      () =>
        setCounter(prevCounter => {
          const nextCounter = prevCounter - 1;

          if (nextCounter === 0) {
            clearInterval(timer);
          }

          return nextCounter;
        }),
      1000
    );

    return () => timer && clearInterval(timer);
  }, [isCounting]);

  const restartCounter = () => setCounter(interval);

  return [counter, isCounting, restartCounter];
}



// WEBPACK FOOTER //
// ./app/hooks/timer.js